var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertsT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    fill: "#4987FF",
    stroke: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 18.3961C37.098 18.7967 36.1441 19.0615 35.168 19.1823C36.1978 18.5525 36.9695 17.5618 37.34 16.3938C36.3723 16.9835 35.3129 17.399 34.208 17.6222C33.4695 16.8024 32.486 16.2566 31.4118 16.0706C30.3376 15.8845 29.2335 16.0687 28.2725 16.5943C27.3116 17.1198 26.5483 17.957 26.1023 18.9745C25.6563 19.992 25.5528 21.1323 25.808 22.2165C23.8513 22.1152 21.9373 21.5936 20.1904 20.6857C18.4434 19.7778 16.9026 18.5039 15.668 16.9466C15.235 17.7207 15.0074 18.5974 15.008 19.4894C15.0065 20.3178 15.2051 21.1338 15.5861 21.8646C15.9672 22.5955 16.5188 23.2185 17.192 23.6783C16.4096 23.6565 15.6439 23.4416 14.96 23.0518V23.1132C14.9659 24.2739 15.3632 25.3969 16.0848 26.2923C16.8064 27.1877 17.8079 27.8004 18.92 28.0269C18.4919 28.1602 18.0475 28.2305 17.6 28.2357C17.2903 28.232 16.9813 28.2032 16.676 28.1497C16.9927 29.1482 17.6055 30.0207 18.4293 30.646C19.253 31.2713 20.2467 31.6182 21.272 31.6384C19.5406 33.033 17.4031 33.7941 15.2 33.8004C14.7989 33.8017 14.3981 33.7771 14 33.7267C16.2493 35.2134 18.8706 36.0026 21.548 35.9992C23.3956 36.0189 25.2286 35.6614 26.9397 34.9478C28.6509 34.2342 30.206 33.1787 31.5142 31.8429C32.8225 30.5072 33.8576 28.9179 34.5591 27.1681C35.2606 25.4182 35.6144 23.5428 35.6 21.6514V21.0004C36.5416 20.2815 37.3538 19.4003 38 18.3961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertsT);
export default __webpack_public_path__ + "static/media/Experts_t.0db155acf5fdcad7630711db428d5645.svg";
export { ForwardRef as ReactComponent };